import type { ReactNode } from "react";
import { hasPermission } from "@vanialabs/core-permissions";
import { useAuthStore } from "@vanialabs/core-auth";
import { useUserContextStore } from "../features/auth/state/userContext.store";

type RequirePermissionProps = {
  module: string;
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
};

export function RequirePermission({
  module,
  permission,
  children,
  fallback = null,
}: RequirePermissionProps) {
  const activeContextId = useAuthStore(
    (state) => state.session?.activeContextId
  );

  const getActiveContext = useUserContextStore(
    (state) => state.getActiveContext
  );

  const activeContext = getActiveContext(activeContextId);

  const allowed = hasPermission(
    activeContext,
    module,
    permission
  );

  if (!allowed) {
    return fallback;
  }

  return children;
}
